import request from '@/router/axios';

export const listByDate = (data) => {
  return request({
    url: '/api/blade-loanOneDayLenging/loanOneDayLenging/listByDate',
    method: 'get',
    params: {
      ...data
    }
  })
}

export const mailOrderList = (data) => {
  return request({
    url: '/api/blade-loanHaveBeenMailed/loanHaveBeenMailed/mailOrderList',
    method: 'get',
    params: {
      ...data
    }
  })
}


/**
 * 代理商概况， 企微消息通知
 * @example '/api/blade-agent/agent/agentOverviewToMsg'
 */
export const agentOverviewList = () => {
  return request({
    url: '/api/blade-agent/agent/agentOverviewToMsg',
    method: 'post'
  })
}

/**
 * 连续代偿的代理商， 企微消息通知
 * @example '/api/blade-agent/agent/getCompensatoryState'
 */
export const agentsContinuousCompensationList = () => {
  return request({
    url: '/api/blade-agent/agent/getCompensatoryState',
    method: 'post'
  })
}

/**
 * 年检到期未处理， 企微消息通知
 * @example '/api/v2/blade-loanPost/loan/annualInspectionDueList'
 */
export const annualInspectionDueList = () => {
  return request({
    url: '/api/v2/blade-loanPost/loan/annualInspectionDueList',
    method: 'post'
  })
}

/**
 * 未邮寄资料停止进件的代理商__企业微信消息通知
 * @default loanInputStoppingCase = 0 '未邮寄资料停止进件的代理商'
 * @example '/api/blade-agent/agent/unmailedMaterialsToMsg'
 */
export const agentsNotMailedStopFeedingList = () => {
  return request({
    url: '/api/blade-agent/agent/unmailedMaterialsToMsg',
    method: 'post',
    params: {
      loanInputStoppingCase: 0
    }
  })
}

/**
 * 未履行代偿停止进件的代理商__企业微信消息通知
 * @default loanInputStoppingCase = 1 '未履行代偿停止进件的代理商'
 * @example '/api/blade-agent/agent/unmailedMaterialsToMsg'
 */
export const agentsNotCompensationStopFeedingList = () => {
  return request({
    url: '/api/blade-agent/agent/unmailedMaterialsToMsg',
    method: 'post',
    params: {
      loanInputStoppingCase: 1
    }
  })
}

/**
 * 未缴纳保证金停止进件的代理商__企业微信消息通知
 * @default loanInputStoppingCase = 2 '未缴纳保证金停止进件的代理商'
 * @example '/api/blade-agent/agent/unmailedMaterialsToMsg'
 */
export const agentsNotDepositPaidStopFeedingList = () => {
  return request({
    url: '/api/blade-agent/agent/unmailedMaterialsToMsg',
    method: 'post',
    params: {
      loanInputStoppingCase: 2
    }
  })
}

/**
 * 保险到期未处理__企业微信消息通知
 * @example '/api/v2/blade-loanPost/loan/insurance-expire'
 */
export const insuranceExpiresDueList = () => {
  return request({
    url: '/api/v2/blade-loanPost/loan/insurance-expire',
    method: 'get'
  })
}

/**
 * 一个月以上未进件的代理商__企业微信消息通知
 * @example '/api/blade-agent/agent/agentNoInput'
 */
export const moreOneMonthStopFeedingList = () => {
  return request({
    url: '/api/blade-agent/agent/agentNoInput',
    method: 'get'
  })
}


/**
 * 代理商签约明细__企业微信消息通知
 * @example '/api/blade-agent/agent/agentSign'
 */
export const agentContractDetailsList = () => {
  return request({
    url: '/api/blade-agent/agent/agentSign',
    method: 'get'
  })
}

